import React, { forwardRef } from 'react'
import { Form } from 'react-bootstrap'
import IFormFieldProps from 'interfaces/form-field-props'
import ErrorField from '../error-field/ErrorField'
import InputLabel from '../input-label/InputLabel'

import styles from './TextArea.module.scss'

type OnChange = React.ChangeEventHandler<
  HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
>

interface ITextAreaField extends IFormFieldProps<OnChange> {
  rows: number
  placeholder?: any
  className?: string
  readOnly?: boolean
  maxLength?: number
}

const TextAreaInput: React.FC<ITextAreaField> = forwardRef<
  HTMLTextAreaElement,
  ITextAreaField
>(
  (
    {
      label,
      placeholder = '',
      className = '',
      value,
      onChange,
      rows = 5,
      error = '',
      readOnly,
      ...rest
    },
    ref
  ) => (
    <>
      <InputLabel label={label || ''} />
      <Form.Control
        as="textarea"
        readOnly={readOnly}
        rows={rows}
        placeholder={placeholder || ''}
        className={`${styles.text} ${className}`}
        value={value}
        onChange={onChange}
        ref={ref}
        {...rest}
      />
      <ErrorField text={error} />
    </>
  )
)

export default TextAreaInput
